import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./Home";
import About from "./About";
// import Connect from "./Connect";
import Portfolio from "./Portfolio";

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/">
        <Home />
      </Route>
      <Route exact path="/about">
        <About />
      </Route>
      <Route exact path="/portfolio">
        <Portfolio />
      </Route>
      {/* <Route exact path="/connect">
        <Connect />
      </Route> */}
    </Switch>
  );
}
